import { APIHandler } from "../../apiHandler";

class NbdimeHandler extends APIHandler {
  async post() {
    this.finish({ is_git: false });
  }
}

export const defaultHandlers: [string, typeof APIHandler][] = [
  ["/nbdime/api/isgit", NbdimeHandler],
];
